import { useSelector } from 'react-redux';

// Design System
import { Message } from 'jl-design-system/components/message/Message';

// Config
import jerseyMessageState from './JerseyMessage.state';

// Components
import Container from '../container';

export const postcodesAffected = ['JE1', 'JE2', 'JE3'];

export const JerseyMessage = () => {
  const showMessage = useSelector(jerseyMessageState);

  return showMessage && (
    <Container background="white" paddingTop="3" paddingX="3">
      <Message
        body="As of July 2023, GST has replaced UK VAT for Jersey-based customers. You can now claim back a 15% concessionary discount after delivery. Selected product lines are excluded. Terms and conditions apply."
        buttonProps={{
          href: 'https://www.johnlewis.com/customer-services/prices-and-payment/vat-receipts-and-refunds',
          tag: 'a',
          rel: 'external',
          target: '_blank',
        }}
        buttonText="Learn more about Jersey GST"
        title="Jersey Goods & Service Tax"
        type="information"
      />
    </Container>
  );
};

export default JerseyMessage;
